import { connectClearRefinements } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { refine, widgetParams } = renderOptions

  if (isFirstRender) {
    const button = document.createElement('button')
    button.classList.add('has-bottom-line', 'link-underline')
    button.classList.add('link-underline--icon')
    button.classList.add('mb-2')
    button.innerHTML = `
    <svg class="icon">
      <use href="#icon-arrow-left" xlink:href="#icon-arrow-left"></use>
    </svg>
    <span class="emphasis">Retour aux thèmes</span>`

    button.addEventListener('click', () => {
      get('[js-training-list-panel][data-panel="subthemes"]').classList.remove('is-visible')

      refine()
    })

    widgetParams.container.appendChild(button)
  }
}

const customClearSubTheme = connectClearRefinements(renderClearRefinements)

export default customClearSubTheme
